import { useService } from "./service.js";
import { useScheduler } from "../utils/scheduler.js";
import { isFunction } from "../utils/is.js";
const scheduler = useScheduler(["update", "render"]);
function createRafService() {
  let isTicking = false;
  function trigger(props2) {
    for (const callback of callbacks.values()) {
      scheduler.update(() => {
        const render = callback(props2);
        if (isFunction(render)) {
          scheduler.render(() => {
            render(props2);
          });
        }
      });
    }
  }
  function loop() {
    props.time = performance.now();
    trigger(props);
    if (!isTicking) {
      return;
    }
    requestAnimationFrame(loop);
  }
  const { add, remove, has, props, callbacks } = useService({
    props: {
      time: performance.now()
    },
    init() {
      isTicking = true;
      requestAnimationFrame(loop);
    },
    kill() {
      isTicking = false;
    }
  });
  return {
    add,
    remove,
    has,
    props: () => props
  };
}
let raf;
function useRaf() {
  if (!raf) {
    raf = createRafService();
  }
  return raf;
}
export {
  useRaf as default
};
//# sourceMappingURL=raf.js.map
